import { put, takeEvery, call, all, select } from "redux-saga/effects";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { push } from "connected-react-router";
import {
  FETCH_LOADDATA_INIT,
  FETCH_LOADDATA_SUCCESS,
  FETCH_LOADDATA_FAIL,
  FETCH_LOADDATABYID_INIT,
  FETCH_LOADDATABYID_SUCCESS,
  FETCH_LOADDATABYID_FAIL,
  FETCH_CARGOTYPE_INIT,
  FETCH_CARGOTYPE_SUCCESS,
  FETCH_CARGOTYPE_FAIL,
  ADD_LOAD_INIT,
  ADD_LOAD_SUCCESS,
  ADD_LOAD_FAIL,
  EDIT_LOAD_INIT,
  EDIT_LOAD_SUCCESS,
  EDIT_LOAD_FAIL,
  FETCH_RUNNERS_INIT,
  FETCH_RUNNERS_SUCCESS,
  FETCH_RUNNERS_FAIL,
  FETCH_CARGOSIZE_INIT,
  FETCH_CARGOSIZE_SUCCESS,
  FETCH_CARGOSIZE_FAIL,
  FETCH_LOADMATRIX_INIT,
  FETCH_LOADMATRIX_SUCCESS,
  FETCH_LOADMATRIX_FAIL,
  GETVEHICLE_INIT,
  GETVEHICLE_SUCCESS,
  GETVEHICLE_FAIL,
  GET_DISTANCE_INIT,
  GET_DISTANCE_SUCCESS,
  GET_DISTANCE_FAIL,
  GET_RATECARD_INIT,
  GET_RATECARD_SUCCESS,
  GET_RATECARD_FAIL,
  GET_PAYMODE_INIT,
  GET_PAYMODE_SUCCESS,
  GET_PAYMODE_FAIL,
  GET_TOTALVEHICLE_INIT,
  GET_TOTALVEHICLE_SUCCESS,
  GET_TOTALVEHICLE_FAIL,
  GET_NEAREST_RUNNERS_INIT,
  GET_NEAREST_RUNNERS_SUCCESS,
  GET_NEAREST_RUNNERS_FAIL,
  GET_SUBSCRIPTION_STATUS,
  GET_SUBSCRIPTION_SUCCESS,
  GET_SUBSCRIPTION_FAIL,
  GET_BID_DATA_BY_ID_ACTION,
  GET_BID_DATA_BY_ID_ACTION_SUCCESS,
  GET_BID_DATA_BY_ID_ACTION_FAIL,
  GET_BID_UPDATE_DATA_BY_ID_ACTION,
  GET_BID_UPDATE_DATA_BY_ID_ACTION_SUCCESS,
  GET_BID_UPDATE_DATA_BY_ID_ACTION_FAIL,
  GET_SPECIFICRUNNER_INIT,
  GET_SPECIFICRUNNER_SUCCESS,
  GET_SPECIFICRUNNER_FAIL,
  GET_SPECIFIC_CARGO_INIT,
  GET_SPECIFIC_CARGO_SUCCESS,
  GET_SPECIFIC_CARGO_FAIL,
  CANCEL_LOAD_INIT,
  CANCEL_LOAD_SUCCESS,
  CANCEL_LOAD_FAIL,
  FETCH_CURRENCY_INIT,
  FETCH_CURRENCY_SUCCESS,
  FETCH_CURRENCY_FAIL,
  FETCH_SUB_FORRUNNER_INIT,
  FETCH_SUB_FORRUNNER_SUCCESS,
  FETCH_SUB_FORRUNNER_FAIL,
  FETCH_PAYCANCELLATION_INIT,
  FETCH_PAYCANCELLATION_SUCCESS,
  FETCH_PAYCANCELLATION_FAIL,
  FETCH_RUNNERVEHICLES_INIT,
  FETCH_RUNNERVEHICLES_SUCCESS,
  FETCH_RUNNERVEHICLES_FAIL
} from "./action";
import { appConfig } from "../../config";
import * as actionTypes from "../UserPlanSbsrptnWarehseContainer/constants";
function* fetchLoaddata(value) {
  const token = localStorage.getItem("token");
  let user = JSON.parse(localStorage.getItem("user"));
  let userorgId = user.orgId;
  let dateFilter = (value.payload && value.payload.dateFilter) || "";

  //For pagination purpose
  let pageno = !value.payload
    ? 1
    : value.payload.page === undefined
    ? 1
    : value.payload.page === 0
    ? 1
    : value.payload.page;
  let status = !value.payload
    ? "created,pending"
    : value.payload.status === undefined
    ? "created,pending"
    : value.payload.status;

  let search = !value.payload
    ? ""
    : value.payload.search === undefined
    ? ""
    : value.payload.search;
  /* let status = !value.value
    ? ""
    : value.value.filter === ""
    ? ""
    : value.value.filter;
  let query = !value.value
    ? ""
    : value.value.queryToSearch === ""
    ? ""
    : value.value.queryToSearch; */

  try {
    const res =
      user.role === "runner"
        ? yield fetch(
            `${appConfig.ip}/loadData?page=${pageno}&limit=10&status=${status}&sort=pickupDate&runnerOrgId=${userorgId}&ser=${search}${dateFilter}`,
            {
              method: "GET",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          )
        : yield fetch(
            `${appConfig.ip}/loadData?page=${pageno}&limit=10&status=${status}&sort=pickupDate&orgId=${userorgId}&ser=${search}${dateFilter}`,
            {
              method: "GET",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          );
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_LOADDATA_SUCCESS,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_LOADDATA_FAIL, error: err });
    } else {
    }
  }
}

function* fetchSpecificLoaddata(value) {
  const token = localStorage.getItem("token");
  let id = value.value;

  try {
    const res = yield fetch(`${appConfig.ip}/loadData/${id}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_LOADDATABYID_SUCCESS,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_LOADDATABYID_FAIL, error: err });
    } else {
    }
  }
}

function* fetchCargotype() {
  const token = localStorage.getItem("token");
  try {
    const res = yield fetch(`${appConfig.ip}/cargoType`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_CARGOTYPE_SUCCESS,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_CARGOTYPE_FAIL, error: err });
    } else {
    }
  }
}

function* addLoad(value) {
  const token = localStorage.getItem("token");
  const state = yield select();

  try {
    if (value.value.payModeName === "online") {
      const res = yield fetch(`${appConfig.ip}/payment/razorPayVerfiy`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          razorPaymentId: value.value.razorPaymentId,
          razorpayOrderId: value.value.razorpayOrderId,
          signature: value.value.signature,
        }),
      });
      if (!res) {
        throw res;
      } else {
        let resJSON = yield res.json();
        if (resJSON.signatureIsValid === true) {
          yield call(addLoadData, value);
        } else {
          yield toast.error("Payment Failed", {
            autoClose: 3000,
            className: "toastClass",
          });
        }
      }
    } else {
      yield call(addLoadData, value);
    }
  } catch (err) {}
}

function* addLoadData(value) {
  const token = localStorage.getItem("token");
  let user = JSON.parse(localStorage.getItem("user"));
  let userOrgId = user.orgId;
  let userCurncyCode = user.curncyCode;
  let cargoDimension = value.value.cargoName;

  const state = yield select(); //to fetch the reducer value
  const vehicleType = state.loadReducer.vehicleType;
  const vehicleTypetoDB = state.loadReducer.vehicleTypetoDB;

  const loadDetails = {
    userId: user.id,
    deliveryType: value.value.delType,
    cargoType: value.value.cargotype,
    pickupDate: new Date(value.value.pickDate).toISOString(),
    pAddr: value.value.pAddr,
    pGeo: value.value.pGeo,
    pFirstName: value.value.pFname,
    //pLName: value.value.pLname,
    pPhnNo: value.value.pPhnNo,
    dropDate: new Date(value.value.dropDate).toISOString(),
    dAddr: value.value.dAddr,
    dGeo: value.value.dGeo,
    dFirstName: value.value.dFname,
    //dLName: value.value.dLname,
    dPhnNo: value.value.dPhnNo,
    //cargoWgt: value.value.cargoWeight,
    cargoSize: value.value.cargoSize,
    runner: value.value.selectedRunner,
    runnerOrgId: value.value.selectedRunnerOrgId,
    noOfUnits: value.value.noOfUnits,
    pNote: value.value.pNote,
    dNote: value.value.dNote,
    orgId: user.orgId,
    pickTime: {
      from: value.value.pickTimefrom,
      to: value.value.pickTimeto,
    },
    dropTime: {
      from: value.value.dropTimefrom,
      to: value.value.dropTimeto,
    },
    vehicleType: vehicleTypetoDB[0], //vehicleType[0]
    rateCard: value.value.rateCardID,
    //loadMetrics: "61d423c886f7b0907b861879",

    payMode:
      value.value.cargoName === "subscription"
        ? value.value.subPayType
        : value.value.payType,
    amount: value.value.amount,
    paymntStatus: value.value.paymntStatus,
    currency: userCurncyCode,
    status: cargoDimension === "Odd size" ? "pending" : "created",
    razorpayOrderId: value.value.razorpayOrderId
      ? value.value.razorpayOrderId
      : "",
    keyword: [user.orgName],
  };

  try {
    const res = yield fetch(`${appConfig.ip}/loadData`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(loadDetails),
    });

    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      try {
        //const data = new FormData();
        let tempDoc = [];

        yield all(
          value.value.loadDoc &&
            value.value.loadDoc.map((loadDoc, i) => {
              const data = new FormData();

              data.append(
                resJSON.id + "-loadDataDoc-" + i + new Date(),
                loadDoc,
                loadDoc.name
              );

              const resDoc = call(`${appConfig.ip}/loadData/doc`, {
                method: "POST",
                headers: {
                  Authorization: `Bearer ${token}`,
                },
                body: data,
              });

              if (!resDoc.ok) {
                throw resDoc;
              } else {
                //const resDocJSON = resDoc.json();
                /* {
      img: resDocJSON.fileName,
      title: "Load document",
      filetype: "jpeg",
    }, */

                tempDoc.push({
                  img: resDoc.json().fileName,
                  title: `Load document-${i}`,
                  filetype: "jpeg",
                });
              }
            })
        );
        /* data.append(
          resJSON.id + "-loadDataDoc-" + new Date(),
          value.value.loadDoc,
          value.value.loadDoc.name
        ); */

        /* const resDoc = yield fetch(`${appConfig.ip}/loadData/doc`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: data,
        }); */

        /* if (!resDoc.ok) {
          console.log("Errrorrrrr");
          throw resDoc;
        } else {
          const resDocJSON = yield resDoc.json();
          console.log(resDocJSON); */
        const updateloadDetails = {
          userId: user.id,
          deliveryType: value.value.delType,
          cargoType: value.value.cargotype,
          pickupDate: new Date(value.value.pickDate).toISOString(),
          pAddr: value.value.pAddr,
          pGeo: value.value.pGeo,
          pFirstName: value.value.pFname,
          //pLName: value.value.pLname,
          pPhnNo: value.value.pPhnNo,
          dropDate: new Date(value.value.dropDate).toISOString(),
          dAddr: value.value.dAddr,
          dGeo: value.value.dGeo,
          dFirstName: value.value.dFname,
          //dLName: value.value.dLname,
          dPhnNo: value.value.dPhnNo,
          //cargoWgt: value.value.cargoWeight,
          cargoSize: value.value.cargoSize,
          runner: value.value.selectedRunner,
          runnerOrgId: value.value.selectedRunnerOrgId,
          noOfUnits: value.value.noOfUnits,
          pNote: value.value.pNote,
          dNote: value.value.dNote,
          orgId: user.orgId,
          pickTime: {
            from: value.value.pickTimefrom,
            to: value.value.pickTimeto,
          },
          dropTime: {
            from: value.value.dropTimefrom,
            to: value.value.dropTimeto,
          },
          vehicleType: vehicleTypetoDB[0], //vehicleType[0]
          rateCard: value.value.rateCardID,
          //loadMetrics: "61d423c886f7b0907b861879",
          doc: tempDoc.length > 0 ? tempDoc : [],
          payMode:
            value.value.cargoName === "subscription"
              ? value.value.subPayType
              : value.value.payType,
          amount: value.value.amount,
          paymntStatus: value.value.paymntStatus,
          currency: userCurncyCode,
          status: cargoDimension === "Odd size" ? "pending" : "created",
          keyword: [user.orgName],
        };

        try {
          const updateres = yield fetch(
            `${appConfig.ip}/loadData/${resJSON.id}`,
            {
              method: "PUT",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
              body: JSON.stringify(updateloadDetails),
            }
          );

          if (!updateres.ok) {
            throw updateres;
          } else {
            const resJSONupdate = yield updateres.json();

            yield put({
              type: ADD_LOAD_SUCCESS,
              payload: resJSONupdate,
            });
            yield put({ type: FETCH_LOADDATA_INIT });
            /* yield toast.success("New load posted", {
              autoClose: 3000,
            }); */
            if (cargoDimension === "Odd size") {
              yield toast.success(
                "Load request sent to the runner for bidding",
                {
                  autoClose: 3000,
                  className: "toastClass",
                }
              );
            } else {
              try {
                let invoiceDetails;
                if (value.value.payModeName === "subscription") {
                  invoiceDetails = {
                    creator: resJSONupdate.runner, //runnerID
                    reciever: resJSONupdate.userId.id,
                    creatorOrgId: resJSONupdate.runnerOrgId,
                    recieverOrgId: userOrgId, //resJSONupdate.userId.orgId,
                    loadId: resJSONupdate.id,
                    loadRefNo: resJSONupdate.loadRefNo,
                    amount: resJSONupdate.amount,
                    type: "load",
                    currency: userCurncyCode, //resJSONupdate.userId.curncyCode,
                    status:
                      value.value.payModeName !== "cash on delivery"
                        ? "paid"
                        : "created",
                    keyword: [user.orgName, value.value.selectedRunnerOrgName], //For search in invoice
                    subscriptnId: state.loadReducer.subscriptionStatus[0].id,
                    subscriptnPlanId:
                      state.loadReducer.subscriptionStatus[0].subscriptnPlan.id,
                    subscriptnNo: state.loadReducer.subscriptionStatus[0].no,
                  };
                } else {
                  invoiceDetails = {
                    creator: resJSONupdate.runner, //runnerID
                    reciever: resJSONupdate.userId.id,
                    creatorOrgId: resJSONupdate.runnerOrgId,
                    recieverOrgId: userOrgId, //resJSONupdate.userId.orgId,
                    loadId: resJSONupdate.id,
                    loadRefNo: resJSONupdate.loadRefNo,
                    amount: resJSONupdate.amount,
                    type: "load",
                    currency: userCurncyCode, //resJSONupdate.userId.curncyCode,
                    status:
                      value.value.payModeName !== "cash on delivery"
                        ? "paid"
                        : "created",
                    keyword: [user.orgName, value.value.selectedRunnerOrgName], //For search in invoice
                    gatewayCharge: value.value.gatewayCharge
                      ? value.value.gatewayCharge
                      : 0,
                    gst: value.value.gst ? value.value.gst : 0,
                  };
                }

                const invoiceres = yield fetch(`${appConfig.ip}/invoice`, {
                  method: "POST",
                  headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                  },
                  body: JSON.stringify(invoiceDetails),
                });

                if (!invoiceres.ok) {
                  throw invoiceres;
                } else {
                  const resJSONinvoice = yield invoiceres.json();
                  /* yield put({
                  type: ADD_LOAD_SUCCESS,
                  payload: resJSONupdate,
                }); */
                  //yield put({ type: FETCH_LOADDATA_INIT });
                  yield toast.success("New load posted", {
                    autoClose: 3000,
                    className: "toastClass",
                  });
                  if (value.value.payModeName === "online") {
                    yield put({
                      type: actionTypes.WAREHOUSESUBSCRIBE_PLAN_SUCCESS_ACTION,
                    });
                  }

                  if (value.value.payModeName !== "cash on delivery") {
                    const gatewayCharge = value.value.gatewayCharge
                      ? value.value.gatewayCharge
                      : 0;
                    const gst = value.value.gst ? value.value.gst : 0;
                    try {
                      const payDetails = {
                        invcNo: resJSONinvoice.no, //Invoice number
                        orgId: userOrgId, //resJSONupdate.userId.orgId, //Shipper orgId
                        userId: resJSONupdate.userId.id, //Shipper id
                        reciever: resJSONupdate.runner, //runner id
                        receiverOrgId: resJSONinvoice.creatorOrgId, //runner orgid
                        loadId: resJSONupdate.id,
                        amount: resJSONinvoice.amount + gatewayCharge + gst,
                        status: "paid",
                        paymentType: resJSONupdate.payMode,
                        invoiceId: resJSONinvoice.id,
                        currency: userCurncyCode, //resJSONupdate.userId.curncyCode,
                        loadRefNo: resJSONinvoice.loadRefNo,
                        type: "load",
                        initiator: resJSONupdate.userId.id, //shipper ID
                        txnRefNo: value.value.refID,
                        razorPaymentId: value.value.razorPaymentId
                          ? value.value.razorPaymentId
                          : "",
                      };

                      const payres = yield fetch(`${appConfig.ip}/payment`, {
                        method: "POST",
                        headers: {
                          Accept: "application/json",
                          "Content-Type": "application/json",
                          Authorization: `Bearer ${token}`,
                        },
                        body: JSON.stringify(payDetails),
                      });

                      if (value.value.payModeName === "subscription") {
                        let subID = state.loadReducer.subscriptionStatus[0].id;

                        try {
                          const subscrptnLog = {
                            /* subscriptnId:
                              state.loadReducer.subscriptionStatus[0]
                                .subscriptnPlan.id, */
                            subscriptnId: subID,
                            loadId: resJSONupdate.id,
                            distance: state.loadReducer.estDistance,
                            noOfLoads: parseInt(value.value.cargoSmallCount),
                          };

                          const updatesubscription = {
                            userId: user.id,
                            runner: value.value.selectedRunner,
                            subscriptnPlan:
                              state.loadReducer.subscriptionStatus[0]
                                .subscriptnPlan.id,
                            distance:
                              parseFloat(
                                state.loadReducer.subscriptionStatus[0].distance
                              ) - parseFloat(state.loadReducer.estDistance),
                            allocatedDist:
                              state.loadReducer.subscriptionStatus[0]
                                .allocatedDist,
                            allocatedLoad:
                              state.loadReducer.subscriptionStatus[0]
                                .allocatedLoad,
                            noOfLoads:
                              parseInt(
                                state.loadReducer.subscriptionStatus[0]
                                  .noOfLoads
                              ) - parseInt(value.value.cargoSmallCount),
                            amount:
                              state.loadReducer.subscriptionStatus[0].amount,
                            currency:
                              state.loadReducer.subscriptionStatus[0]
                                .currency &&
                              state.loadReducer.subscriptionStatus[0].currency
                                .id,
                            paymentType:
                              state.loadReducer.subscriptionStatus[0]
                                .paymentType &&
                              state.loadReducer.subscriptionStatus[0]
                                .paymentType.id,
                            validityTo:
                              state.loadReducer.subscriptionStatus[0]
                                .validityTo,
                            validityFrom:
                              state.loadReducer.subscriptionStatus[0]
                                .validityFrom,
                            runnerOrgId:
                              state.loadReducer.subscriptionStatus[0]
                                .runnerOrgId,
                          };

                          const subLogres = yield fetch(
                            `${appConfig.ip}/subscriptionlog`,
                            {
                              method: "POST",
                              headers: {
                                Accept: "application/json",
                                "Content-Type": "application/json",
                                Authorization: `Bearer ${token}`,
                              },
                              body: JSON.stringify(subscrptnLog),
                            }
                          );

                          const updatesubres = yield fetch(
                            `${appConfig.ip}/subscriptn/${subID}`,
                            {
                              method: "PUT",
                              headers: {
                                Accept: "application/json",
                                "Content-Type": "application/json",
                                Authorization: `Bearer ${token}`,
                              },
                              body: JSON.stringify(updatesubscription),
                            }
                          );
                        } catch (err) {
                          console.log(err);
                        }
                      }
                    } catch (err) {}
                  }
                }
              } catch (err) {
                yield toast.info("Unknown error- Invoice not created", {
                  autoClose: 3000,
                  className: "toastClass",
                });
              }
            }
          }
        } catch (err) {
          if (err.ok === false) {
            yield put({ type: ADD_LOAD_FAIL, error: err });
            yield toast.info("Unknown error", {
              autoClose: 3000,
              className: "toastClass",
            });
          } else {
          }
        }
        /* } */
      } catch (err) {}
    }
  } catch (err) {}
}

function* editLoad(value) {
  const token = localStorage.getItem("token");
  let user = JSON.parse(localStorage.getItem("user"));
  let userCurncyCode = user.curncyCode;

  const state = yield select(); //to fetch the reducer value
  const vehicleType = state.loadReducer.vehicleType;

  let id = value.value.id;

  const loadDetails = {
    userId: user.id,
    deliveryType: value.value.delType,
    cargoType: value.value.cargotype,
    pickupDate: new Date(value.value.pickDate).toISOString(),
    pAddr: value.value.pAddr,
    pGeo: value.value.pGeo,
    pFirstName: value.value.pFname,
    //pLName: value.value.pLname,
    pPhnNo: value.value.pPhnNo,
    dropDate: new Date(value.value.dropDate).toISOString(),
    dAddr: value.value.dAddr,
    dGeo: value.value.dGeo,
    dFirstName: value.value.dFname,
    //dLName: value.value.dLname,
    dPhnNo: value.value.dPhnNo,
    //cargoWgt: value.value.cargoWeight,
    cargoSize: value.value.cargoSize,
    runner: value.value.selectedRunner,
    runnerOrgId: value.value.selectedRunnerOrgId,
    noOfUnits: value.value.noOfUnits,
    pNote: value.value.pNote,
    dNote: value.value.dNote,
    orgId: user.orgId,
    pickTime: {
      from: value.value.pickTimefrom,
      to: value.value.pickTimeto,
    },
    dropTime: {
      from: value.value.dropTimefrom,
      to: value.value.dropTimeto,
    },
    vehicleType: vehicleType[0],
    rateCard: value.value.rateCardID,
    //loadMetrics: "61d423c886f7b0907b861879",
    payMode:
      value.value.cargoName === "subscription"
        ? value.value.subPayType
        : value.value.payType,
    amount: value.value.amount,
    paymntStatus: value.value.paymntStatus,
    currency: userCurncyCode,
  };

  try {
    const res = yield fetch(`${appConfig.ip}/loadData/${id}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(loadDetails),
    });

    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: EDIT_LOAD_SUCCESS,
        payload: resJSON,
      });
      yield put({ type: FETCH_LOADDATA_INIT });
      yield toast.success("Load details updated", {
        autoClose: 3000,
        className: "toastClass",
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: EDIT_LOAD_FAIL, error: err });
      yield toast.info("Unknown error", {
        autoClose: 3000,
        className: "toastClass",
      });
    } else {
    }
  }
}

function* fetchRunners() {
  const token = localStorage.getItem("token");

  try {
    const res = yield fetch(`${appConfig.ip}/users?role=runner`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_RUNNERS_SUCCESS,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_RUNNERS_FAIL, error: err });
    } else {
    }
  }
}

function* fetchCargoSize() {
  const token = localStorage.getItem("token");

  try {
    const res = yield fetch(`${appConfig.ip}/cargoSize`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_CARGOSIZE_SUCCESS,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_CARGOSIZE_FAIL, error: err });
    } else {
    }
  }
}

function* fetchLoadmatrix() {
  const token = localStorage.getItem("token");
  try {
    const res = yield fetch(`${appConfig.ip}/loadMetrics?isActive=true`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_LOADMATRIX_SUCCESS,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_LOADMATRIX_FAIL, error: err });
    } else {
    }
  }
}

function* getVehicleType(value) {
  const token = localStorage.getItem("token");
  let units = value.payload;

  try {
    const res = yield fetch(
      `${appConfig.ip}/loadMetricsMap/getVehicleType?noOfUnits=${units}&isActive=true`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: GETVEHICLE_SUCCESS,
        originalpayload: resJSON,
        payload: [
          ...new Map(resJSON.data.map((v) => [v.subCatgry, v])).values(),
        ],
      });
      //yield put({ type: GET_RATECARD_INIT });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: GETVEHICLE_FAIL, error: err });
    } else {
    }
  }
}

function* getDistance(value) {
  const token = localStorage.getItem("token");
  let user = JSON.parse(localStorage.getItem("user"));

  const geoDetails = {
    pGeo: value.payload.pGeo,
    dGeo: value.payload.dGeo,
  };

  try {
    const res = yield fetch(`${appConfig.ip}/web/placeSuggest/getDist`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(geoDetails),
    });

    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: GET_DISTANCE_SUCCESS,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: GET_DISTANCE_FAIL, error: err });
    } else {
    }
    {
    }
  }
}

function* getRateCard(value) {
  const token = localStorage.getItem("token");
  let runnerID = value.payload;
  const state = yield select(); //to fetch the reducer value
  const vehicleType = state.loadReducer.vehicleType;
  console.log(state.loadReducer.vehicleType);
  console.log(state.loadReducer.vehicleTypetoDB);

  try {
    const res = yield fetch(
      `${appConfig.ip}/rateCard/runnerRateCard?subCatgry=${vehicleType}&runnerId=${runnerID}&isActive=true
      `,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: GET_RATECARD_SUCCESS,
        payload: resJSON.rows,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: GET_RATECARD_FAIL, error: err });
    } else {
    }
  }
}

function* getPaymentMode() {
  const token = localStorage.getItem("token");
  try {
    const res = yield fetch(`${appConfig.ip}/paymentMode?type=load`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: GET_PAYMODE_SUCCESS,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: GET_PAYMODE_FAIL, error: err });
    } else {
    }
  }
}

function* getVehicles() {
  const token = localStorage.getItem("token");
  try {
    const res = yield fetch(`${appConfig.ip}/vehicleInvntry`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: GET_TOTALVEHICLE_SUCCESS,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: GET_TOTALVEHICLE_FAIL, error: err });
    } else {
    }
  }
}

function* getNearestRunners(value) {
  const token = localStorage.getItem("token");
  let pickGeo = value.value;

  try {
    const res = yield fetch(
      `${appConfig.ip}/runnerOperatingLoc/getNearest?near=${pickGeo}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      let filteredresJSON = resJSON.rows.filter(
        (runner) =>
          runner.runnerId.status === "active" && runner.radius > runner.distance
      );

      let tempArray = [];
      [...new Map(filteredresJSON.map((o) => [o.runnerId._id, o])).values()]
        .length > 0 &&
        [
          ...new Map(filteredresJSON.map((o) => [o.runnerId._id, o])).values(),
        ].map((item) => {
          tempArray.push(item.runnerId._id);
        });
      yield put({
        type: GET_NEAREST_RUNNERS_SUCCESS,
        payload: filteredresJSON,
        tempPayload: tempArray,
      });
      yield put({ type: GET_RATECARD_INIT, payload: tempArray });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: GET_NEAREST_RUNNERS_FAIL, error: err });
    } else {
    }
  }
}

function* fetchSubscriptionStatus(value) {
  const token = localStorage.getItem("token");
  let runnerOrgID = value.value;

  let user = JSON.parse(localStorage.getItem("user"));
  let userorgId = user.orgId;

  try {
    const res = yield fetch(
      `${appConfig.ip}/subscriptn?runnerOrgId=${runnerOrgID}&orgId=${userorgId}&status=active`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: GET_SUBSCRIPTION_SUCCESS,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: GET_SUBSCRIPTION_FAIL, error: err });
    } else {
    }
  }
}

function* fetchBidDataByIdStatus(value) {
  const token = localStorage.getItem("token");
  let runnerOrgID = value.value;

  let user = JSON.parse(localStorage.getItem("user"));
  let userorgId = user.orgId;

  try {
    const res = yield fetch(`${appConfig.ip}/bid?loadId=${value.value}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: GET_BID_DATA_BY_ID_ACTION_SUCCESS,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: GET_BID_DATA_BY_ID_ACTION_FAIL, error: err });
    } else {
    }
  }
}
function* updateBidDataByIdStatus(value) {
  const token = localStorage.getItem("token");
  const state = yield select();
  try {
    if (
      value.value.paymentData &&
      value.value.paymentData.payModeName === "online"
    ) {
      const res = yield fetch(`${appConfig.ip}/payment/razorPayVerfiy`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          razorPaymentId: value.value.paymentData.razorPaymentId,
          razorpayOrderId: value.value.paymentData.razorpayOrderId,
          signature: value.value.paymentData.signature,
        }),
      });
      if (!res) {
        throw res;
      } else {
        let resJSON = yield res.json();
        if (resJSON.signatureIsValid === true) {
          yield call(updateBid, value);
        } else {
          yield toast.error("Payment Failed", {
            autoClose: 3000,
            className: "toastClass",
          });
        }
      }
    } else {
      yield call(updateBid, value);
    }
  } catch (err) {}
}

function* updateBid(value) {
  let bid_id = value.value.bid[0].id;
  let loadId = value.value.load.id;
  const token = localStorage.getItem("token");
  let user = JSON.parse(localStorage.getItem("user"));

  try {
    const res = yield fetch(`${appConfig.ip}/bid/${bid_id}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ status: value.value.status }),
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      if (value.value.status === "accepted") {
        yield call(updateLoad, value);
      } else if (value.value.status === "rejected") {
        yield toast.success("Bid rejected", {
          autoClose: 3000,
          className: "toastClass",
        });
        yield call(updateLoad, value);
      }
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: GET_BID_UPDATE_DATA_BY_ID_ACTION_FAIL, error: err });
    } else {
    }
  }
}

function* updateLoad(value) {
  try {
    const token = localStorage.getItem("token");
    let user = JSON.parse(localStorage.getItem("user"));
    let userOrgId = user.orgId;
    let userID = user.id;

    const state = yield select(); //to fetch the reducer value
    const vehicleType = state.loadReducer.vehicleType;
    let id = value.value.load.id;

    let vehicleData = [];

    value.value.bid[0].vehicleType &&
      value.value.bid[0].vehicleType.map((el) => {
        vehicleData.push({
          vehicleId: el.subCat && el.subCat.id,
          name: el.subCat && el.subCat.name,
          noOfUnits: el.noOfVehicle,
        });
      });
    let loadDetails;
    if (value.value.status === "accepted") {
      loadDetails = {
        status: "bid",
        vehicleType: vehicleData,
        amount: value.value.amount,
        payMode: value.value.paymentData.payType,
        paymntStatus: value.value.paymentData.paymntStatus,
        razorpayOrderId: value.value.paymentData.razorpayOrderId
          ? value.value.paymentData.razorpayOrderId
          : "",
      };
    } else if (value.value.status === "rejected") {
      loadDetails = {
        status: value.value.status,
        vehicleType: vehicleData,
        amount: value.value.amount,
      };
    }

    const res = yield fetch(`${appConfig.ip}/loadData/${id}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(loadDetails),
    });

    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      if (value.value.status === "accepted") {
        try {
          const invoiceDetails = {
            creator: value.value.load.runner, //runnerID
            reciever: userID,
            creatorOrgId: value.value.load.runnerOrgId,
            recieverOrgId: userOrgId, //resJSONupdate.userId.orgId,
            loadId: value.value.load.id,
            loadRefNo: value.value.load.loadRefNo,
            amount: value.value.amount,
            type: "load",
            currency: value.value.load.currency, //resJSONupdate.userId.curncyCode,
            gatewayCharge: value.value.paymentData.gatewayCharge
              ? value.value.paymentData.gatewayCharge
              : 0,
            gst: value.value.paymentData.gst ? value.value.paymentData.gst : 0,
            keyword: [user.orgName, value.value.bid[0].bidUserId.orgName],
          };

          const invoiceres = yield fetch(`${appConfig.ip}/invoice`, {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(invoiceDetails),
          });

          if (!invoiceres.ok) {
            throw invoiceres;
          } else {
            const resJSONinvoice = yield invoiceres.json();

            yield toast.success("Bid succesfully approved", {
              autoClose: 3000,
              className: "toastClass",
            });
            if (value.value.paymentData.paymntStatus === "paid") {
              const gatewayCharge = value.value.paymentData.gatewayCharge
                ? value.value.paymentData.gatewayCharge
                : 0;
              const gst = value.value.paymentData.gst
                ? value.value.paymentData.gst
                : 0;
              try {
                const payDetails = {
                  invcNo: resJSONinvoice.no, //Invoice number
                  orgId: userOrgId, //resJSONupdate.userId.orgId, //Shipper orgId
                  userId: userID, //Shipper id
                  reciever: value.value.load.runner, //runner id
                  receiverOrgId: value.value.load.runnerOrgId, //runner orgid
                  loadId: value.value.load.id,
                  amount: value.value.amount + gatewayCharge + gst,
                  status: "paid",
                  paymentType: value.value.paymentData.payType,
                  invoiceId: resJSONinvoice.id,
                  currency: value.value.load.currency, //resJSONupdate.userId.curncyCode,
                  loadRefNo: value.value.load.loadRefNo,
                  type: "load",
                  initiator: userID, //shipper ID
                  txnRefNo: value.value.paymentData.refID,
                  razorPaymentId:
                    value.value.paymentData &&
                    value.value.paymentData.razorPaymentId
                      ? value.value.paymentData.razorPaymentId
                      : "",
                };

                const payres = yield fetch(`${appConfig.ip}/payment`, {
                  method: "POST",
                  headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                  },
                  body: JSON.stringify(payDetails),
                });
              } catch {
                yield toast.info("Unknown error- Invoice not created", {
                  autoClose: 3000,
                  className: "toastClass",
                });
              }
            }
          }
        } catch {}
      }
      yield put({
        type: EDIT_LOAD_SUCCESS,
        payload: resJSON,
      });
      yield put({
        type: FETCH_LOADDATA_INIT,
        payload: { status: "bid" },
      });
      if (value.value.paymentData.payModeName === "online") {
        yield put({
          type: actionTypes.WAREHOUSESUBSCRIBE_PLAN_SUCCESS_ACTION,
        });
      }
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: EDIT_LOAD_FAIL, error: err });
      yield toast.info("Unknown error", {
        autoClose: 3000,
        className: "toastClass",
      });
    } else {
    }
  }
}

function* fetchSpecificRunner(value) {
  const token = localStorage.getItem("token");
  let runnerID = value.value;

  try {
    const res = yield fetch(`${appConfig.ip}/licenseeProf/${runnerID}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: GET_SPECIFICRUNNER_SUCCESS,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: GET_SPECIFICRUNNER_FAIL, error: err });
    } else {
    }
  }
}

function* fetchSpecificCargo(value) {
  const token = localStorage.getItem("token");
  let cargoID = value.value;

  try {
    const res = yield fetch(`${appConfig.ip}/cargoSize/${cargoID}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: GET_SPECIFIC_CARGO_SUCCESS,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: GET_SPECIFIC_CARGO_FAIL, error: err });
    } else {
    }
  }
}

function* cancelLoad(value) {
  const token = localStorage.getItem("token");
  let user = JSON.parse(localStorage.getItem("user"));

  let loadID = value.value.id;

  const state = yield select(); //to fetch the reducer value
  const bidPayMode = state.loadReducer.bidPayMode;
  const codPayMode = state.loadReducer.codPayMode;
  const subscriptionPayMode = state.loadReducer.subscriptionPayMode;

  const loadDetails = {
    status: "cancelled",
    paymntStatus: "cancelled",
  };

  const invoiceBody = {
    status: "canceld",
    creator: value.value.runner,
    reciever: user.id,
    amount: value.value.amount,
    currency: value.value.currency,
  };

  const payBody = {
    status: "cancelled",
  };

  if (value.value.paymntStatus === "not paid") {
    if (value.value.payMode === bidPayMode[0].id) {
      try {
        const res = yield fetch(
          `${appConfig.ip}/loadData/updateLoad/${loadID}`,
          {
            method: "PUT",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(loadDetails),
          }
        );

        if (!res.ok) {
          throw res;
        } else {
          const resJSON = yield res.json();
          yield put({
            type: CANCEL_LOAD_SUCCESS,
            payload: resJSON,
          });

          value.value.status === "bid"
            ? yield put({
                type: FETCH_LOADDATA_INIT,
                payload: { status: "bid" },
              })
            : yield put({
                type: FETCH_LOADDATA_INIT,
                payload: { status: "created,pending" },
              });

          yield toast.info("You have succesfully cancelled the load posted", {
            autoClose: 3000,
            className: "toastClass",
          });
        }
      } catch (err) {
        if (err.ok === false) {
          yield put({ type: CANCEL_LOAD_FAIL, error: err });
        } else {
        }
      }
    } else {
      try {
        const res = yield fetch(
          `${appConfig.ip}/loadData/updateLoad/${loadID}`,
          {
            method: "PUT",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(loadDetails),
          }
        );

        if (!res.ok) {
          throw res;
        } else {
          const resJSON = yield res.json();
          try {
            const resInvoice = yield fetch(
              `${appConfig.ip}/invoice?loadId=${loadID}`,
              {
                method: "GET",
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
                },
              }
            );

            if (!resInvoice.ok) {
              throw resInvoice;
            } else {
              const resInvoiceJSON = yield resInvoice.json();
              const invoiceID = resInvoiceJSON.rows[0].id;

              try {
                const res1 = yield fetch(
                  `${appConfig.ip}/invoice/${invoiceID}`,
                  {
                    method: "PUT",
                    headers: {
                      Accept: "application/json",
                      "Content-Type": "application/json",
                      Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify(invoiceBody),
                  }
                );

                if (!res1.ok) {
                  throw res1;
                } else {
                  yield put({
                    type: CANCEL_LOAD_SUCCESS,
                    payload: resJSON,
                  });
                  value.value.status === "bid"
                    ? yield put({
                        type: FETCH_LOADDATA_INIT,
                        payload: { status: "bid" },
                      })
                    : yield put({
                        type: FETCH_LOADDATA_INIT,
                        payload: { status: "created,pending" },
                      });
                  yield toast.info(
                    "You have succesfully cancelled the load posted",
                    {
                      autoClose: 3000,
                      className: "toastClass",
                    }
                  );
                }
              } catch (err) {
                if (err.ok === false) {
                  console.log("Invoice not cancelled");
                } else {
                }
              }
            }
          } catch (err) {}
        }
      } catch (err) {
        if (err.ok === false) {
          yield put({ type: CANCEL_LOAD_FAIL, error: err });
        } else {
        }
      }
    }
  } else {
    try {
      const res = yield fetch(`${appConfig.ip}/loadData/updateLoad/${loadID}`, {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(loadDetails),
      });

      if (!res.ok) {
        throw res;
      } else {
        const resJSON = yield res.json();
        try {
          const resInvoice = yield fetch(
            `${appConfig.ip}/invoice?loadId=${loadID}`,
            {
              method: "GET",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          );

          if (!resInvoice.ok) {
            throw resInvoice;
          } else {
            const resInvoiceJSON = yield resInvoice.json();
            const invoiceID = resInvoiceJSON.rows[0].id;

            try {
              const res1 = yield fetch(`${appConfig.ip}/invoice/${invoiceID}`, {
                method: "PUT",
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(invoiceBody),
              });

              if (!res1.ok) {
                throw res1;
              } else {
                try {
                  const resPay = yield fetch(
                    `${appConfig.ip}/payment?loadId=${loadID}`,
                    {
                      method: "GET",
                      headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                      },
                    }
                  );

                  if (!resPay.ok) {
                    throw resPay;
                  } else {
                    const resPayJSON = yield resPay.json();
                    const payID = resPayJSON.rows[0].id;

                    try {
                      const res2 = yield fetch(
                        `${appConfig.ip}/payment/${payID}`,
                        {
                          method: "PUT",
                          headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`,
                          },
                          body: JSON.stringify(payBody),
                        }
                      );

                      if (!res2.ok) {
                        throw res2;
                      } else {
                        const subRevision = {
                          loadId: value.value.id,
                        };

                        const cancelRequest = {
                          status: "created",
                          invoiceId: resInvoiceJSON.rows[0].id,
                          paymentId: resPayJSON.rows[0].id,
                          paymentMode: value.value.payMode,
                          loadId: value.value.id,
                          orgId: user.orgId,
                        };
                        if (value.value.payMode === subscriptionPayMode[0].id) {
                          try {
                            const ressubRevise = yield fetch(
                              `${appConfig.ip}/subscriptn/cancelLoad`,
                              {
                                method: "POST",
                                headers: {
                                  Accept: "application/json",
                                  "Content-Type": "application/json",
                                  Authorization: `Bearer ${token}`,
                                },
                                body: JSON.stringify(subRevision),
                              }
                            );

                            if (!ressubRevise.ok) {
                              throw ressubRevise;
                            } else {
                              yield put({
                                type: CANCEL_LOAD_SUCCESS,
                                payload: resJSON,
                              });
                              yield put({
                                type: FETCH_LOADDATA_INIT,
                                payload: { status: "created,pending" },
                              });
                              yield toast.info(
                                "You have succesfully cancelled the load posted and the created invoice has been cancelled. The used points will be reimbursed to the used subscription, if the validity is not expired",
                                {
                                  autoClose: 3000,
                                  className: "toastClass",
                                }
                              );
                            }
                          } catch (err) {
                            console.log("Subscription revision not done");
                          }
                        } else {
                          try {
                            const resCanclRqst = yield fetch(
                              `${appConfig.ip}/cancellationRqst`,
                              {
                                method: "POST",
                                headers: {
                                  Accept: "application/json",
                                  "Content-Type": "application/json",
                                  Authorization: `Bearer ${token}`,
                                },
                                body: JSON.stringify(cancelRequest),
                              }
                            );

                            if (!resCanclRqst.ok) {
                              throw resCanclRqst;
                            } else {
                              yield put({
                                type: CANCEL_LOAD_SUCCESS,
                                payload: resJSON,
                              });

                              value.value.status === "bid"
                                ? yield put({
                                    type: FETCH_LOADDATA_INIT,
                                    payload: { status: "bid" },
                                  })
                                : yield put({
                                    type: FETCH_LOADDATA_INIT,
                                    payload: { status: "created,pending" },
                                  });

                              yield toast.info(
                                "You have succesfully cancelled the load posted and the created invoice has been cancelled. A request for payment cancellation is sent to the Admin",
                                {
                                  autoClose: 3000,
                                  className: "toastClass",
                                }
                              );
                            }
                          } catch (err) {
                            console.log(
                              "Payment cancellation request not sent!!"
                            );
                          }
                        }
                      }
                    } catch (err) {
                      if (err.ok === false) {
                        console.log("Payment not cancelled");
                      } else {
                      }
                    }
                  }
                } catch (err) {
                  if (err.ok === false) {
                    console.log("Cannot fetch the payment");
                  } else {
                  }
                }
              }
            } catch (err) {
              console.log("Cannot update the invoice status to cancelled");
            }
          }
        } catch (err) {
          console.log("Cannot fetch the invoice");
        }
      }
    } catch (err) {
      if (err.ok === false) {
        yield put({ type: CANCEL_LOAD_FAIL, error: err });
      } else {
      }
    }
  }
}

function* fetchcurrency() {
  try {
    const token = localStorage.getItem("token");
    const res = yield fetch(`${appConfig.ip}/currency`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_CURRENCY_SUCCESS,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_CURRENCY_FAIL, error: err });
    } else {
    }
  }
}

function* fetchSubscriptionagainstRunner(value) {
  try {
    const token = localStorage.getItem("token");
    let user = JSON.parse(localStorage.getItem("user"));
    let userId = user.id;
    let runnerOrgId = value.value;

    const res = yield fetch(
      `${appConfig.ip}/subscriptn?userId=${userId}&runnerOrgId=${runnerOrgId}&status=active`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_SUB_FORRUNNER_SUCCESS,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_SUB_FORRUNNER_FAIL, error: err });
    } else {
    }
  }
}

function* fetchPaymentCancellation(value) {
  try {
    const token = localStorage.getItem("token");
    let user = JSON.parse(localStorage.getItem("user"));
    let loadId = value.value;

    const res = yield fetch(
      `${appConfig.ip}/cancellationRqst?loadId=${loadId}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_PAYCANCELLATION_SUCCESS,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_PAYCANCELLATION_FAIL, error: err });
    } else {
    }
  }
}

function* fetchTheRunnerVehicles(value) {
  try {
    const token = localStorage.getItem("token");
    let orgId = value.value;

    const res = yield fetch(
      `${appConfig.ip}/vehicleInvntry?orgId=${orgId}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_RUNNERVEHICLES_SUCCESS,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_RUNNERVEHICLES_FAIL, error: err });
    } else {
    }
  }
}

export function* LoadDataActionWatcher() {
  yield takeEvery(FETCH_LOADDATA_INIT, fetchLoaddata);
  yield takeEvery(FETCH_LOADDATABYID_INIT, fetchSpecificLoaddata);
  yield takeEvery(FETCH_CARGOTYPE_INIT, fetchCargotype);
  yield takeEvery(ADD_LOAD_INIT, addLoad);
  yield takeEvery(EDIT_LOAD_INIT, editLoad);
  yield takeEvery(FETCH_RUNNERS_INIT, fetchRunners);
  yield takeEvery(FETCH_CARGOSIZE_INIT, fetchCargoSize);
  yield takeEvery(FETCH_LOADMATRIX_INIT, fetchLoadmatrix);
  yield takeEvery(GETVEHICLE_INIT, getVehicleType);
  yield takeEvery(GET_DISTANCE_INIT, getDistance);
  yield takeEvery(GET_RATECARD_INIT, getRateCard);
  yield takeEvery(GET_PAYMODE_INIT, getPaymentMode);
  yield takeEvery(GET_TOTALVEHICLE_INIT, getVehicles);
  yield takeEvery(GET_NEAREST_RUNNERS_INIT, getNearestRunners);
  yield takeEvery(GET_SUBSCRIPTION_STATUS, fetchSubscriptionStatus);
  yield takeEvery(GET_BID_DATA_BY_ID_ACTION, fetchBidDataByIdStatus);
  yield takeEvery(GET_BID_UPDATE_DATA_BY_ID_ACTION, updateBidDataByIdStatus);
  yield takeEvery(GET_SPECIFICRUNNER_INIT, fetchSpecificRunner);
  yield takeEvery(GET_SPECIFIC_CARGO_INIT, fetchSpecificCargo);
  yield takeEvery(CANCEL_LOAD_INIT, cancelLoad);
  yield takeEvery(FETCH_CURRENCY_INIT, fetchcurrency);
  yield takeEvery(FETCH_SUB_FORRUNNER_INIT, fetchSubscriptionagainstRunner);
  yield takeEvery(FETCH_PAYCANCELLATION_INIT, fetchPaymentCancellation);
  yield takeEvery(FETCH_RUNNERVEHICLES_INIT,fetchTheRunnerVehicles);
}
